/**
 * @generated SignedSource<<c1aed9b79ded38ee5e960c75d3d6da43>>
 * @relayHash 4dccfb345a03f362a171efbed26fae84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 20b50ca19300dd1b5ee2d33125429c8a18c63be647c9815bf5ddc55cc46e3077

import type { ConcreteRequest } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateRichTextFieldInput = {
  id: string;
  operation: JiraRichTextFieldOperationInput;
};
export type JiraRichTextFieldOperationInput = {
  document: JiraADFInput;
  operation: JiraSingleValueFieldOperations;
};
export type JiraADFInput = {
  jsonValue?: AGG$JSON | null;
  version?: number | null;
};
export type AgenticPlanToolMutation$variables = {
  input: JiraUpdateRichTextFieldInput;
};
export type AgenticPlanToolMutation$data = {
  readonly jira: {
    readonly updateRichTextField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null;
      }> | null;
      readonly field: {
        readonly richText: {
          readonly adfValue: {
            readonly json: AGG$JSON | null;
          } | null;
        } | null;
      } | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type AgenticPlanToolMutation = {
  response: AgenticPlanToolMutation$data;
  variables: AgenticPlanToolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "concreteType": "JiraRichText",
  "kind": "LinkedField",
  "name": "richText",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraADF",
      "kind": "LinkedField",
      "name": "adfValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "json"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgenticPlanToolMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRichTextFieldPayload",
            "kind": "LinkedField",
            "name": "updateRichTextField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraRichTextField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgenticPlanToolMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRichTextFieldPayload",
            "kind": "LinkedField",
            "name": "updateRichTextField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraRichTextField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "20b50ca19300dd1b5ee2d33125429c8a18c63be647c9815bf5ddc55cc46e3077",
    "metadata": {},
    "name": "AgenticPlanToolMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7bc30f89696d9f7e23b706360d93af32";

export default node;
